import type { FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import type { AllocationOverview } from '../../api.js';
import { AllocationPanel } from '../../components/AllocationPanel.js';

interface PartnerAllocationTabProps {
  allocation?: AllocationOverview;
  allocCredit: string;
  allocUnlimited: boolean;
  busy: boolean;
  onCreditChange: (value: string) => void;
  onUnlimitedChange: (value: boolean) => void;
  onSave: (event: FormEvent) => void;
}

export function PartnerAllocationTab({
  allocation,
  allocCredit,
  allocUnlimited,
  busy,
  onCreditChange,
  onUnlimitedChange,
  onSave
}: PartnerAllocationTabProps) {
  const { t } = useTranslation();
  return (
    <section className="panel">
      <AllocationPanel
        label={t('partners.allocation')}
        overview={allocation}
        credit={allocCredit}
        unlimited={allocUnlimited}
        allowUnlimited={true}
        busy={busy}
        onCreditChange={onCreditChange}
        onUnlimitedChange={onUnlimitedChange}
        onSave={onSave}
        framed={false}
      />
    </section>
  );
}
